import { BudgetAPI } from "@griffingroupglobal/eslib-api";

const rejectPendingUpdatesHandler = async (props) => {
  const { reference, budgetLastUpdated, budgetId, reason } = props;

  const response = await BudgetAPI.postByIdWOP(budgetId, "$reject", {
    lastUpdated: budgetLastUpdated,
    reference,
    reason,
  });
  return response.data;
};

export default rejectPendingUpdatesHandler;
